import { Switch } from "@/components/ui/switch";
import { CUSTOM_FILTERS } from "@/config/list";
import type { ListFilters } from "@/types/list";

interface OwnAlarmsToggleProps {
	filter: ListFilters;
}

export const OwnAlarmsToggle = ({ filter }: OwnAlarmsToggleProps) => {
	const checked = filter.getFilter(CUSTOM_FILTERS.ownAlarms) === true;

	const handleChange = (next: boolean) => {
		if (next) {
			filter.setFilter(CUSTOM_FILTERS.ownAlarms, true);
		} else {
			filter.clearFilter(CUSTOM_FILTERS.ownAlarms);
		}
	};

	return (
		<div className="flex flex-col space-y-1">
			<span className="text-xs font-medium text-muted-foreground">Scope</span>
			<label className="flex items-center gap-2 h-9 px-3 rounded-md border bg-background cursor-pointer select-none">
				<Switch checked={checked} onCheckedChange={handleChange} />
				<span className="text-sm font-medium">Own Alarms</span>
			</label>
		</div>
	);
};
